window.CareerLadder = (selectorID, introPostContent, careerLadder) => {
return {
		selectorID: selectorID,
		introPostContent: JSON.parse(introPostContent),
		careerLadder: JSON.parse(careerLadder),
		currIndex: -1,
		traversedPath: [],

		/**
		 * Updates the state of all values on the click of
		 * each path button and displays the new post.
		 *
		 * @param {*} newIndex 
		 */
		selectPath(newIndex) {
			this.currIndex = newIndex;

			if (newIndex == -1) {
				this.traversedPath = [];
				this.displayIntroContent();
			} else {
				if (newIndex == 0) {
					this.traversedPath = [0];
				} else if (this.traversedPath.includes(newIndex)) {
					var untilIndex = this.traversedPath.findIndex((n) => n === newIndex) + 1;
					this.traversedPath = this.traversedPath.slice(0, untilIndex);
				} else {
					this.traversedPath.push(newIndex);
				}
				this.displayContent();
			}

			this.createNavigation();
		},

		/**
		 * Given the values of the button that called it, return
		 * if the button should be disabled or not.
		 * Base case is for the 
		 *
		 * @param {*} currPathName 
		 * @param {*} currIndex 
		 * @returns boolean
		 */
		isDisabled(currPathName, currIndex) {
			if (this.currIndex == -1) {
				return true;
			}

			var isNext = this.careerLadder[this.currIndex].nav.next.includes(currPathName);
			var beenTraversed = this.traversedPath.includes(currIndex);

			return !isNext && !beenTraversed;
		},

		/**
		 * Given the values of the button that called it, return
		 * if the button is in the current traversed path but is 
		 * not the currently selected path.
		 *
		 * @param {*} currIndex 
		 * @return boolean
		 */
		isInPath(currIndex) {
			return this.traversedPath.includes(currIndex);
		},

		/** 
		 * Use the global variables to grab the current post content
		 * and inject into the inner html of the info wrapper div.
		 * This function is also where the navigational buttons are
		 * injected into the info.
		 */
		displayContent() {
			var postContent = this.careerLadder[this.currIndex].post;
			const ladderWrapper = document.querySelector(`#career-ladder-info${this.selectorID}`);
			ladderWrapper.innerHTML = postContent; 
		},

		/** 
		 * Use the global intro post content to display when the career 
		 * ladder has yet to be traversed. AKA, in the start of the loop.
		 * This function is also where the starting navigational
		 * buttons are injected to the info.
		 */
		displayIntroContent() {
			const ladderWrapper = document.querySelector(`#career-ladder-info${this.selectorID}`);
			ladderWrapper.innerHTML = this.introPostContent; 
		},

		/**
		 * Dynamically builds the navigational buttons inside a 
		 * wrapper that is injected into the current post
		 * content. Calls all of the button constructors here,
		 * as they all take care of their edge cases in their
		 * respective function.
		 */
		createNavigation() {
			const navDiv = document.createElement('div');
			navDiv.classList.add('navigational-buttons');

			const defaultBtnDiv = document.createElement('div');
			defaultBtnDiv.classList.add('default-nav-btns');

			const startBtn       = this.createStartBtn();
			const selectNextBtns = this.createSelectNextBtns()
			const backBtn        = this.createBackBtn();
			const restartBtn     = this.createRestartBtn();
			const nextArrowBtn   = this.createNextArrowBtn();

			if (startBtn) {
				navDiv.append(startBtn);
			}
			if (selectNextBtns) {
				navDiv.append(selectNextBtns);
			}
			if (backBtn) {
				defaultBtnDiv.append(backBtn);
			}
			if (restartBtn) {
				defaultBtnDiv.append(restartBtn);
			}
			if (nextArrowBtn) {
				defaultBtnDiv.append(nextArrowBtn);
			}

			navDiv.append(defaultBtnDiv);

			const ladderWrapper = document.querySelector(`#career-ladder-info${this.selectorID}`);
			const videoResourcesWrapper = ladderWrapper.querySelector("[id^='sections-video-resources-block']");
			
			if (videoResourcesWrapper) {
				videoResourcesWrapper.before(navDiv);
			} else {
				ladderWrapper.append(navDiv);
			}
		}, 

		/**
		 * Creates the button to start traversing the Career Ladder.
		 * When clicked, the first path will be shown. 
		 * 
		 * @returns an HMTL button element or nothing
		 */
		createStartBtn() {
			if (this.currIndex != -1) { return; }

			const startBtn = document.createElement('button');
			startBtn.classList.add('start-button', 'default-button');
			startBtn.textContent = 'Start Here';

			startBtn.addEventListener('click', () => this.selectPath(0));

			return startBtn;
		},

		/**
		 * Creates the button to traverse backwards on the Career 
		 * Ladder. When clicked, the previous path will be shown. 
		 * 
		 * @returns an HMTL button element or nothing
		 */
		createBackBtn() {
			var length = this.traversedPath.length;
			if (length <= 0) { return; }
			
			const backBtn = document.createElement('button');
			backBtn.classList.add('back-button', 'default-button');
			backBtn.innerHTML = '<svg width="26" height="19" class="fill-white rotate-90 transition-colors duration-200" viewbox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 17.699.419 4.499c-.559-.637-.559-1.67 0-2.306l1.35-1.54C2.324.019 3.228.018 3.786.652L13 11.112 22.213.651c.559-.634 1.462-.633 2.019.003l1.35 1.54c.558.636.558 1.668 0 2.305l-11.571 13.2c-.559.636-1.463.636-2.021 0"/></svg>'
			
			var index = length - 2;
			if (index < 0) {
				var path = -1;
			} else {
				var path = this.traversedPath[index];
			}
			backBtn.addEventListener('click', () => this.selectPath(path));

			return backBtn;
		},

		/**
		 * Creates the named next path options. When clicked, that
		 * path will be selected and become the current path.
		 *
		 * @returns a new div element with 1 - 3 buttons linking to
		 * the next path options or nothing
		 */
		createSelectNextBtns() {
			// Current: Intro or Last Path
			if (this.currIndex == -1 || this.currIndex == this.careerLadder.length - 1) { return; }

			var currPath = this.careerLadder[this.currIndex];

			// Error Handling
			if (currPath.nav.next.length === undefined) { return; }

			// Current: Has at least 1 next path
			if (currPath.nav.next.length >= 1) {

				const btnContainer = document.createElement('div');
				btnContainer.classList.add('select-next-btns')

				for (let i = 0; i < currPath.nav.next.length; i++) {
					let nextPath = currPath.nav.next[i];
					
					const nextBtn = document.createElement('button');
					nextBtn.classList.add('next-button-select', 'inverted-button');
					nextBtn.innerHTML = `<p class="pr-[10px] m-0 leading-none text-[20px] font-bold">${nextPath}</p> <svg width="26" height="19" class="fill-branch-green -rotate-90 transition-colors duration-200 flex-shrink-0" viewbox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 17.699.419 4.499c-.559-.637-.559-1.67 0-2.306l1.35-1.54C2.324.019 3.228.018 3.786.652L13 11.112 22.213.651c.559-.634 1.462-.633 2.019.003l1.35 1.54c.558.636.558 1.668 0 2.305l-11.571 13.2c-.559.636-1.463.636-2.021 0"/></svg>`

					const targetIndex = this.careerLadder.findIndex(path => path.name === nextPath);

					nextBtn.addEventListener('click', () => this.selectPath(targetIndex));

					btnContainer.appendChild(nextBtn);
				}
				return btnContainer;
			}
		},

		/**
		 * Creates the next arrow button that display only if
		 * there is one next option. When clicked, the only
		 * next path will be selected.
		 * 
		 * @returns the next button or nothing
		 */
		createNextArrowBtn() {
			// Current: Intro or Last Path
			if (this.currIndex == -1 || this.currIndex == this.careerLadder.length - 1) { return; }

			var currPath = this.careerLadder[this.currIndex];

			// Error Handling
			if (currPath.nav.next.length === undefined) { return; }

			// Current: Has only one next path
			if (currPath.nav.next.length == 1) {
				const nextBtn = document.createElement('button');
				nextBtn.classList.add('next-button-arrow', 'default-button');
				nextBtn.innerHTML = '<svg width="26" height="19" class="fill-white -rotate-90 transition-colors duration-200" viewbox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 17.699.419 4.499c-.559-.637-.559-1.67 0-2.306l1.35-1.54C2.324.019 3.228.018 3.786.652L13 11.112 22.213.651c.559-.634 1.462-.633 2.019.003l1.35 1.54c.558.636.558 1.668 0 2.305l-11.571 13.2c-.559.636-1.463.636-2.021 0"/></svg>'

				var targetIndex = this.careerLadder.findIndex(path => path.name === currPath.nav.next[0]);

				nextBtn.addEventListener('click', () => this.selectPath(targetIndex));

				return nextBtn;
			}
		},

		/**
		 * Creates the button to restart the Career Ladder. When
		 * clicked, the intro post content will be shown. This button
		 * will not be shown on the intro post. 
		 * 
		 * @returns an HMTL button element or nothing
		 */
		createRestartBtn() {
			if (this.currIndex == -1) { return; }

			const restartBtn = document.createElement('button');
			restartBtn.classList.add('restart-button', 'default-button');
			restartBtn.innerHTML = '<svg width="24" height="25" viewBox="0 0 24 25" class="fill-white transition-colors duration-200" xmlns="http://www.w3.org/2000/svg"><path d="m7.944 4.95 5.844-3.638a.714.714 0 0 1 .897.142l.516.615a.506.506 0 0 1-.122.777l-4.633 2.9 3.509 4.192a.506.506 0 0 1-.125.776l-.681.425a.714.714 0 0 1-.897-.142L7.82 5.729a.506.506 0 0 1 .123-.778"/><path d="M9.737 4.764A9.119 9.119 0 1 1 5.442 7.26l2.183 2.11a6.084 6.084 0 1 0 2.865-1.666z" stroke-width="12"/></svg>'

			restartBtn.addEventListener('click', () => this.selectPath(-1));

			return restartBtn;
		},

		/**
		 * Function to run on initial load that displays the first index's 
		 * post content. Can also be used for debugging.
		 */
		init() {
			this.displayIntroContent();
			this.createNavigation();

			// Log for debugging ----------
			// console.log(this.careerLadder);
			// console.log(this.traversedPath);
		}
	};
};
